import React, { useState, useEffect } from 'react';
import Game from '../../../../class/Game/Game';
import ProviderGames from './ProviderGames';
import LOAD_GAMES_BY_PROVIDER_ID from '../../modal/load_games_by_provider_id';
import Games from '../../../../class/Game_copy/Game';




import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { useTranslation } from 'react-i18next';


const ProviderListCasino = ({ AuthService, category, isLogged, setIsLoginModalOpen  }) => {
  const { t } = useTranslation();
  const [providers, setProviders] = useState([]);
  const [loadedProviders, setLoadedProviders] = useState([]);
  const [loading, setLoading] = useState(true);
  const user_id = AuthService.getCustom('user_id');

  const [selectedProvider, setSelectedProvider] = useState(null);
  const [showGamesModalSingleProvider, setshowGamesModalSingleProvider] = useState(false);

  const openSingleProvidersModal = (provider) => {
    setSelectedProvider(provider);
    setshowGamesModalSingleProvider(true);
  };

  const closeGamesModal = () => {
    setSelectedProvider(null);
    setshowGamesModalSingleProvider(false);
  };



  useEffect(() => {
    const fetchProviders = async () => {
      try {
        let userId = user_id ?? '';

        const data = await Games.getProviders(userId,category);
        // console.log("Category: " + category);

        // console.log("PROVIDERS: ");
        // console.log(data);

        const allProviders = data.params.providers || [];

        setProviders(allProviders);
        setLoading(false);
        for (const provider of allProviders) {
          try {
            await new Promise(resolve => setTimeout(resolve, 200));
            setLoadedProviders(prevState => [...prevState, provider]);
          } catch (error) {
            console.error(`Error loading provider ${provider.id}:`, error);
          }
        }


        // const providerData = await Game.getProviderActive(user_id, category);
        // const allProviders = providerData.data.data || [];
        // setProviders(allProviders);
        // setLoading(false);

        // for (const provider of allProviders) {
        //   try {
        //     await new Promise(resolve => setTimeout(resolve, 200));
        //     setLoadedProviders(prevState => [...prevState, provider]);
        //   } catch (error) {
        //     console.error(`Error loading provider ${provider.id}:`, error);
        //   }
        // }
      } catch (error) {
        console.error('Error fetching providers:', error);
        setLoading(false);
      }
    };

    fetchProviders();
  }, [user_id]);



  const settings = {
    dots: false,
    infinite: true,
    speed: 800,
    slidesToShow: 6,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const renderLoadingGames = () => {
    return Array.from({ length: 6 }).map((_, index) => (
     
      <div key={index} className="HomeSectionCasinoGames_game">
        <div className="CasinoGameCard_root">
          <div className="CasinoGamePreview_root blurred">
            <div className="CasinoGamePreview_gradient"></div>
            <img
              className="ResponsivePicture_img CasinoGamePreview_image"
              src="https://storage.googleapis.com/camasy-images/casino/only__play__619cb11478244.png"
              style={{ filter: 'blur(10px)' }}
              alt="Loading..."
            />
          </div>
          <div className="CasinoGameCard_info CasinoGameCard_withProvider">
            <div className="CasinoGameCard_icon_placeholder"></div>
            <p className="CasinoGameCard_name_placeholder" style={{ filter: 'blur(10px)' }}>{t('loading')}...</p>
          </div>
          </div>
        
      </div>
    ));
  };

  const renderLoadingProviders = () => {
    return Array.from({ length: 2 }).map((_, index) => (
      <div key={index} className="body main-layout-item">
        <div className="Home_root">
          <div className="Home_games">
            <div className="Home_header">
              <a href="#" className="HomeSection_header">
                <img
                  alt="Provider"
                  src="https://via.placeholder.com/50"
                  className="HomeSection_icon"
                />
                <div className="HomeSection_label">{t('loading')}...</div>
                <div className="HomeSection_right">
                  <div className="HomeSection_headerLink"></div>
                  <div className="HomeSection_caption">0 {t('Games')}</div>
                </div>
              </a>
            </div>
            <div className="HomeSectionCasinoGames_list">
              {renderLoadingGames()}
            </div>
          </div>
        </div>
      </div>
    ));
  };

  return (
    <div>
      {loadedProviders.map(provider => (
        <ProviderGames
          key={provider.id}
          provider={provider}
          user_id={user_id}
          cetegory={category}
          AuthService={AuthService}
          isLogged={isLogged}
          setIsLoginModalOpen={setIsLoginModalOpen}
        />
      ))}

      {loading || loadedProviders.length < providers.length
        ?  <Slider {...settings}>{renderLoadingGames()}</Slider>
        : null}

    </div>
  );
};

export default ProviderListCasino;